import React from 'react';

const BrowserIcon = ({size=1}) => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" fill='#296adb' width={24*size} viewBox="0 0 512 512"><path d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"/></svg>
    );
};

export default BrowserIcon;